import { useState } from "react";

const MAX_LENGTH = 500;

export default function TipBox() {
  const [content, setContent] = useState("");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = () => {
    if (!content.trim()) {
      setFeedback("先写点线索内容，再递给我们吧。");
      return;
    }
    setFeedback("已收到你的线索（演示效果），编辑部会尽快查看。");
    setContent("");
  };

  return (
    <section id="tips" className="border-b border-background-200 bg-background-50 scroll-mt-32">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              <i className="ri-megaphone-line"></i>
              匿名爆料通道
            </span>
            <h3 className="mt-4 font-heading text-2xl md:text-3xl font-bold leading-snug">
              你手上的那条线索，可能就是明天的话题墙
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              把公开可见的截图、时间点或链接整理一下写下来。我们只做信息汇总与时间线梳理，不涉及任何私人信息。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                支持图文线索
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                可匿名提交
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                24 小时内查看
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-6">
              <label htmlFor="tip-content" className="text-sm font-medium text-foreground-800">
                线索内容
              </label>
              <textarea
                id="tip-content"
                value={content}
                onChange={(event) => setContent(event.target.value.slice(0, MAX_LENGTH))}
                placeholder="例如：某综艺官微在凌晨 2 点修改了置顶文案，前后截图如下……"
                rows={6}
                className="mt-2 w-full resize-none rounded-md border border-background-200 bg-background-50 p-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
              <div className="mt-2 flex items-center justify-between gap-3">
                <span className="text-xs text-foreground-400">
                  内容仅作演示，不会真实提交
                </span>
                <span className="text-xs text-foreground-500 tabular-nums">
                  {content.length} / {MAX_LENGTH}
                </span>
              </div>

              <div className="mt-4 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                <span className="text-xs text-foreground-500">
                  <i className="ri-lock-line mr-1"></i>
                  我们不会公开你的身份信息
                </span>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  提交线索
                </button>
              </div>

              {feedback && (
                <p className="mt-3 rounded-md bg-accent-100 px-3 py-2 text-sm text-accent-900">
                  {feedback}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}